import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  resourceList: [],
}

export const getters = {}

export const mutations = {
  CACHE_RESOURCE_LIST(state, newList) {
    state.resourceList = newList
  },
}

export const actions = {
  // Resource List Service
  fetchResourceList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/resources/?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_RESOURCE_LIST', list)
        return list
      })
  },

  // Add Resource Service
  addResourceData({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/resources`, Data)
      .then((response) => {
        const resource = response.data
        return resource
      })
  },

  // Update Resource
  updateResourceData({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/resources/${Data.id}`, Data)
      .then((response) => {
        const assignment = response.data
        return assignment
      })
  },

  deleteResourceData({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/resources/${Data.id}`)
      .then((response) => {
        const resource = response.data
        return resource
      })
  },
}
